export const SUPPORTED_LANGUAGES = [
  'nl', 'en', 'pl', 'ro', 'bg', 'hu', 'de', 'es', 'pt', 'uk', 'tr', 'lt', 'cs', 'sk',
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export interface LanguageConfig {
  code: SupportedLanguage;
  label: string;
  countryCode: string;
}

export const LANGUAGE_CONFIG: LanguageConfig[] = [
  { code: 'nl', label: 'Nederlands', countryCode: 'NL' },
  { code: 'en', label: 'English', countryCode: 'GB' },
  { code: 'pl', label: 'Polski', countryCode: 'PL' },
  { code: 'ro', label: 'Română', countryCode: 'RO' },
  { code: 'bg', label: 'Български', countryCode: 'BG' },
  { code: 'hu', label: 'Magyar', countryCode: 'HU' },
  { code: 'de', label: 'Deutsch', countryCode: 'DE' },
  { code: 'es', label: 'Español', countryCode: 'ES' },
  { code: 'pt', label: 'Português', countryCode: 'PT' },
  { code: 'uk', label: 'Українська', countryCode: 'UA' },
  { code: 'tr', label: 'Türkçe', countryCode: 'TR' },
  { code: 'lt', label: 'Lietuvių', countryCode: 'LT' },
  { code: 'cs', label: 'Čeština', countryCode: 'CZ' },
  { code: 'sk', label: 'Slovenčina', countryCode: 'SK' },
];
